import Vue from 'vue'
import VueRouter from 'vue-router'
import login from "@/components/auth/login";
import store from '../store'
import contradiction from "@/components/contradiction/contradiction";
import CallCenter from "@/components/callCenter/CallCenter";
import SaleYearlyDashboard from "@/components/dashboard/SaleYearlyDashboard";
import CustomerRFM from "@/components/dashboard/CustomerRFM";
import EmployeeLocations from "../components/Locations/EmployeeLocations";
import OrderTrace from "@/components/OrderTrace/OrderTrace";
import FactorsList from "@/components/Factor/FactorsList";
import RemainOrder from "@/components/orders/RemainOrder";
import AllWayBillList from "@/components/WayBill/AllWayBillList";
import Inventorylist from "@/components/products/Inventorylist";
import GoodsTransfer from "@/components/store/GoodsTransfer";
import FinancialClaims from "@/components/Deboters/FinancialClaims";
import DriverList from "@/components/Driver/DriverList";
import PayDocument from "@/components/PayDocument/PayDocument";
import ExitDocumentList from "@/components/ExitDocuments/ExitDocumentList";
import Questionnaire from "@/components/CustomerQuestions/Questionnaire";
import CustomerDashboard from "@/components/customers/CustomerDashboard";
import UsersList from "@/components/Users/UsersList";
import BuyOrder from "@/components/Buys/BuyOrder";
import BuyOrderTrace from "@/components/Buys/BuyOrderTrace";
import FullView from "@/components/admin/FullView";
import MyOrderList from "@/components/Visitors/MyOrderList";
import TotalBuyFactors from "@/components/Buys/TotalBuyFactors.vue";
import DriverOwnRemittance from "@/components/Driver/DriverOwnRemittance.vue";
import GoodsGroupManagement from "@/components/GoodsGroup/GoodsGroupManagement.vue";
import BuyYearlyDashboard from "@/components/dashboard/BuyYearlyDashboard.vue";
import ReportViewer from "@/components/Reports/ReportViewer.vue";
import ReportMinusStor from "@/components/Reports/ReportMinusStor.vue";
import WarehouseHandling from "@/components/Reports/WarehouseHandling.vue";
import GoodsPriceList from "@/components/GoodsPrice/GoodsPriceList.vue";
import Transactions from "@/components/Finnotech/Transactions.vue";
import GetWayBillBalanceInfo from "@/components/Driver/GetWayBillBalanceInfo.vue";
import StorageBoilingPoint from "@/components/products/StorageBoilingPoint.vue";
import BuyRequest from "@/components/Buys/BuyRequest.vue";
import ShopBoilingPoint from "@/components/Shop/ShopBoilingPoint.vue";
import GoodsGroupTreeManagement from "@/components/GoodsGroup/GoodsGroupTreeManagement.vue";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../components/OrderTrace/OrderTrace'),
        meta: {
            requiresAuth: true,
            role: ["admin", "user"]
        }
    },
    {
        path: '/sale_targets/:type',
        name: 'sale_targets',
        component: () => import('../components/SaleTargets/SaleTargetList'),
        meta: {
            requiresAuth: true,
            role: ["admin", "salemanager"]
        }
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        props:true,
        component: () => import('../components/generals/Home'),
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_operation_function"]
        }
    },
    {
        path: '/dashboard-duration',
        name: 'dashboard-duration',
        props:true,
        component: () => import('../components/generals/Home'),
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_operation_function"]
        }
    },
    {
        path: '/sale_dashboard',
        name: 'SaleDashboard',
        component: () => import('../components/dashboard/SaleDashboard'),
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_30days_report"]
        }
    },
    {
        name: "login",
        path: "/login",
        component: login,
        meta: {
            requiresAuth: false,
            role: ["admin", "user"]
        }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import('../components/generals/About.vue'),
        meta: {
            requiresAuth: true,
            role: ["admin", "user"]
        }
    },
    {
        path: '/customers-search/:type',
        props: true,
        name: 'CustomerSearch',
        component: () => import('../components/customers/CustomerSearch'),
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_customer_list", "management"]
        }
    },
    {
        path: '/orders-list/:id?/:state?',
        props: true,
        name: 'OrdersList',
        component: () => import('../components/orders/OrdersList'),
        meta: {
            requiresAuth: true,
            role: ["admin", "can_issue_order"]
        }
    },
    {
        path: '/shop-order',
        props: true,
        name: 'ShopOrdersList',
        component: () => import('../components/Shop/ShopOrder/ShopOrderPanel.vue'),
        meta: {
            requiresAuth: true,
            role: ["admin", "can_entry_shop_order"]
        }
    },
    {
        path: '/products-search',
        name: 'ProductSearch',
        component: () => import('../components/productInfo/ProductInfo'),
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_products_list","management"]
        }
    },
    {
        path: '/settings',
        name: 'SettingsPanel',
        component: () => import('../components/settings/SettingsPanel'),
        meta: {
            requiresAuth: true,
            role: ["admin", "user", "can_access_settings"]
        }
    },
    {
        path: '/my',
        name: 'RequestsList',
        component: () => import('../components/requests/RequestsList'),
        meta: {
            requiresAuth: true,
            role: ["admin", "user", "can_sea_cartabl"]
        }
    },
    {
        path: '/shop-request',
        name: 'ShopRequestList',
        component: () => import('../components/Shop/ShopRequest.vue'),
        meta: {
            requiresAuth: true,
            role: ["admin", "user", "can_manage_shop"]
        }
    },
    {
        name: "contradiction",
        path: "/contradiction/:id",
        component: contradiction,
        meta: {
            requiresAuth: true,
            role: ["admin", "finance"]
        }
    },
    {
        name: "sale_yearly_dashboard",
        path: "/sale_yearly_dashboard/:id?",
        component: SaleYearlyDashboard,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_yearly_report"]
        }
    },
    {
        name: "call_center",
        path: "/call_center",
        component: CallCenter,
        meta: {
            requiresAuth: true,
            role: ["admin", "free_call"]
        }
    },
    {
        name: "customer_rfm",
        path: "/customer_frm",
        component: CustomerRFM,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_frm"]
        }
    },
    {
        name: "orderTrace",
        path: "/order-trace",
        component: OrderTrace,
        meta: {
            requiresAuth: true,
            role: ["admin", "salemanager", "can_sea_order_trace", "can_issue_way_bill"]
        }
    },
    {
        name: "locations",
        path: "/locations",
        component: EmployeeLocations,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_sea_employee_locations"]
        }
    },
    {
        name: "factors",
        path: "/factors",
        component: FactorsList,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_all_factors"]
        }
    },
    {
        name: "remain-orders",
        path: "/remain-orders",
        component: RemainOrder,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_remain_order"]
        }
    },
    {
        name: "all-way-bill",
        path: "/all-way-bill",
        component: AllWayBillList,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_all_way_bill"]
        }
    },
    {
        name: "inventory_list",
        path: "/inventory_list",
        component: Inventorylist,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_inventory_list", "can_only_numerical_exists_store"]
        }
    },
    {
        name: "goods_transfer",
        path: "/goods_transfer",
        component: GoodsTransfer,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_goods_transfer"]
        }
    },
    {
        name: "list-of-financial-claims",
        path: "/list-of-financial-claims",
        component: FinancialClaims,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_customer_Demands"]
        }
    },
    {
        name: "list-of-drivers",
        path: "/list-of-drivers",
        component: DriverList,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_manage_drivers"]
        }
    },
    {
        name: "pay-documents",
        path: "/pay-documents",
        component: PayDocument,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_pay_document"]
        }
    },
    {
        name: "exit-documents",
        path: "/exit-documents",
        component: ExitDocumentList,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_exit_product_document"]
        }
    },
    {
        name: "questionnaire",
        path: "/questionnaire",
        component: Questionnaire,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_manage_questionanire"]
        }
    },
    {
        name: "customerDashboard",
        path: "/customer-dashboard/:customerId",
        props: true,
        component: CustomerDashboard,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_customer_list"]
        }
    },
    {
        name: "users",
        path: "/users",
        props: true,
        component: UsersList,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_manage_users"]
        }
    },
    {
        name: "buy_order",
        path: "/buy_order/:id?/:customerId?",
        props: true,
        component: BuyOrder,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_entry_buy_goods_order"]
        }
    },
    {
        name: "buyOrderTrace",
        path: "/buy_order_trace",
        props: true,
        component: BuyOrderTrace,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_buy_order_trace"]
        }
    },
    {
        name: "SellBuyOrderTrace",
        path: "/sell_buy_order_trace",
        props: true,
        component: FullView,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_sell_buy_order_trace"]
        }
    },
    {
        name: "MyOrderList",
        path: "/my_order_list",
        props: true,
        component: MyOrderList,
        meta: {
            requiresAuth: true,
            role: ["user_visitor", "user_sell","user_store"]
        }
    },
    {
        name: "TotalBuyFactors",
        path: "/total_buy_factors",
        props: true,
        component: TotalBuyFactors,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_buy_order_trace"]
        }
    },
    {
        name: "DriverRemittanceList",
        path: "/driver_remittance_list",
        props: true,
        component: DriverOwnRemittance,
        meta: {
            requiresAuth: true,
            role: ["admin", "user_driver"]
        }
    },
    {
        name: "GoodsGroupManagement",
        path: "/goods-groups",
        props: true,
        component: GoodsGroupManagement,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_manage_goods_group","management"]
        }
    },
    {
        name: "GoodsGroupTreeManagement",
        path: "/goods-groups-tree",
        props: true,
        component: GoodsGroupTreeManagement,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_manage_goods_group","management"]
        }
    },
    {
        name: "BuyYearlyReport",
        path: "/buy_yearly_dashboard",
        props: true,
        component: BuyYearlyDashboard,
        meta: {
            requiresAuth: true,
            role: ["admin", "user_purchase"]
        }
    },
    {
        name: "Reports",
        path: "/reports",
        props: true,
        component: ReportViewer,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_report_menu"]
        }
    },
    {
        name: "ReportStorMinus",
        path: "/reports-stor-minus",
        props: true,
        component: ReportMinusStor,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_report_menu"]
        }
    },
    {
        name: "ReportsWarehouseHandling",
        path: "/reports-warehouse-handling",
        props: true,
        component: WarehouseHandling,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_report_menu"]
        }
    },
    {
        name: "GoodsPrice",
        path: "/goods-price",
        props: true,
        component: GoodsPriceList,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_change_goods_price"]
        }
    },
    {
        name: "GetTransactions",
        path: "/get-transaction",
        props: true,
        component: Transactions,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_main_account_transactions"]
        }
    },
    {
        name: "GetDriversBalanceInfo",
        path: "/get-drivers-balance-info",
        props: true,
        component: GetWayBillBalanceInfo,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_see_drivers_balance-info","user_driver"]
        }
    },
    {
        name: "StorageBoilingPoint",
        path: "/get-storage_boiling_point",
        props: true,
        component: StorageBoilingPoint,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_show_storage_boiling_point_page"]
        }
    },
    {
        name: "BuyRequest",
        path: "/buy_request/:id?/:customerId?",
        props: true,
        component: BuyRequest,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_send_buy_request"]
        }
    },
    {
        name: "ShopBoilingPoint",
        path: "/shop_boiling_point",
        props: true,
        component: ShopBoilingPoint,
        meta: {
            requiresAuth: true,
            role: ["admin", "can_manage_shop"]
        }
    },
]

const router = new VueRouter({
    mode: 'hash',
    history: true,
    linkActiveClass: "active",
    base: process.env.BASE_URL,
    hashbang: true,
    root: "/home",
    routes
})
router.beforeEach(async (to, from, next) => {
    let token = window.localStorage.getItem("access_token");
    if (token !== null) {
        store.state.isLogged = true;
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.state.isLogged) {
            next({name: 'login'})
        } else {
            if (to.meta.role.some(v => store.state.roles.includes(v))) {
                next()
            }
        }
    } else {
        next()
    }
});
export default router
